import { useReactive } from 'ahooks';
import { Col, Row, theme } from 'antd';
import { FC } from 'react';

import { BaseQueryParams } from '@/common/interfaces';

import { SearchConsoleAnalyticsRowKeysColor, useGetSearchConsoleAnalyticsMutation } from '@/modules/Domains';

import { SearchConsoleAnalyticsChartView, SearchConsoleAnalyticsNoChartView } from './SearchConsoleAnalyticsChart';
import { SearchConsoleAnalyticsTablesTabsView } from './SearchConsoleAnalyticsTablesTabs';

interface Props {
  result: (BaseQueryParams<typeof useGetSearchConsoleAnalyticsMutation>['data']);
}

export const SearchConsoleAnalyticsResultView: FC<Props> = ({ result }) => {
  const { default: defaultData, ...dimensionsData } = result.data;

  const { token: { blue6, purple6, green6, orange6 } } = theme.useToken();

  const itemsColor = useReactive<SearchConsoleAnalyticsRowKeysColor>({
    clicks: blue6,
    impressions: purple6,
    ctr: green6,
    position: orange6
  });

  const noRealData = dimensionsData?.dates?.every(
    d => d.clicks === 0 && d.impressions === 0 && d.ctr === 0 && d.position === 0
  ) ?? false;

  return (
    <Row wrap gutter={ [0, 16] }>
      <Col span={ 24 }>
        <div style={{ position: 'relative', width: '100%' }}>
          { noRealData && <SearchConsoleAnalyticsNoChartView/> }

          <SearchConsoleAnalyticsChartView
            noRealData={ noRealData }
            itemsColor={ itemsColor }
            datesRows={ dimensionsData.dates }
            defaultValues={ defaultData }
          />
        </div>
      </Col>

      <Col span={ 24 }>
        <SearchConsoleAnalyticsTablesTabsView
          itemsColor={ itemsColor }
          dimensionsRows={ dimensionsData }
        />
      </Col>
    </Row>
  );
};
